import { useInfiniteQuery } from '@tanstack/react-query';
import { getInvoices } from 'Services/invoices';
import { trackError } from 'Utils/errorMonitoring';
import { RESULTS_PER_PAGE } from 'Utils/constants';
import useIntegrations from './useIntegrations';

export default function useInfiniteInvoices(filters, options = {}) {
    const response = useInfiniteQuery(
        ['invoices', filters],
        async ({ pageParam = 1 }) => {
            const response = await getInvoices({
                ...filters,
                page: pageParam,
            });

            return response;
        },
        {
            keepPreviousData: true,
            ...options,
            refetchOnWindowFocus: true,
            staleTime: 1000,
            onError: (err) => trackError(err),
            getNextPageParam: (lastPage, allPages) => {
                const pagesLoaded = allPages.length;
                const totalPages = Math.ceil(lastPage.count / RESULTS_PER_PAGE);
                return pagesLoaded < totalPages ? pagesLoaded + 1 : false;
            },
        },
    );

    const { integrations } = useIntegrations();

    const formattedPages = response.data?.pages?.map((page) => {
        return {
            ...page,
            items: (page.items ?? []).map((invoice) => {
                return {
                    ...invoice,
                    integration: invoice.integration_id
                        ? integrations?.find((integration) => integration.id === invoice.integration_id)
                        : null,
                };
            }),
        };
    });

    return {
        ...response,
        data: {
            ...response.data,
            pages: formattedPages,
        },
    };
}
